import { App } from 'vue';
import { AppAbility, defineAbilitiesFor } from '~/common/abilities/Ability';
import { createMongoAbility } from '@casl/ability';

// Create the ability instance
const ability = createMongoAbility<AppAbility>();

export default {
  install(app: App) {
    const userStore = useUserStore();

    // Update abilities initially based on user roles/permissions
    ability.update(
      defineAbilitiesFor({
        roles: userStore.roles,
        permissions: userStore.permissions,
        features: userStore.features,
      }),
    );

    // Update abilities if roles/permissions change
    userStore.$subscribe(() => {
      ability.update(
        defineAbilitiesFor({
          roles: userStore.roles,
          permissions: userStore.permissions,
          features: userStore.features,
        }),
      );
    });

    app.config.globalProperties.$ability = ability;

    // Add helper methods
    app.config.globalProperties.$can = ability.can.bind(ability);
    app.config.globalProperties.$canAny = (
      action: string,
      subjects: string[],
    ) => {
      return subjects.some((subject) => ability.can(action, subject));
    };
  },
};

// Export ability and the plugin
export { ability };
